/**
 * Heal vignette: a full-screen green edge glow that flashes when the player
 * uses the medkit, then fades. Mirror of DamageVignette but green + a slower
 * fade so a heal reads as a soothing pulse rather than a hit. Non-obstructing
 * radial gradient, transparent through the centre, `pointer-events: none`.
 */
export class HealVignette {
  private readonly el: HTMLDivElement;
  private strength = 0;

  constructor(parent: HTMLElement) {
    const el = document.createElement('div');
    el.className = 'heal-vignette';
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.pointerEvents = 'none';
    el.style.opacity = '0';
    el.style.zIndex = '30';
    el.style.background =
      'radial-gradient(ellipse at center, rgba(40,255,120,0) 52%, rgba(30,180,90,0.32) 82%, rgba(40,230,120,0.6) 100%)';
    parent.appendChild(el);
    this.el = el;
  }

  /** Flash the vignette; `amount` in ~[0,1] scales the spike. */
  pulse(amount = 1): void {
    this.strength = Math.min(1, this.strength + Math.max(0, amount));
    this.el.style.opacity = String(this.strength);
  }

  /** Fade the flash out. Call each frame with the frame delta (seconds). */
  update(dtSec: number): void {
    if (this.strength <= 0) return;
    this.strength = Math.max(0, this.strength - dtSec * 1.6); // ~0.6s fade
    this.el.style.opacity = String(this.strength);
  }
}
